module.exports = __webpack_public_path__ + "img/template-04.783a35bc.jpg";